import { SubscriptionPricingModel } from "../../models/subscription";
import { usePricing } from "../../../store/subscription/usePricing";
import _ from "lodash";


export default class SubscriptionPricingController {


  setTable = usePricing.getState().actions.setTable
  setLoading = usePricing.getState().actions.setLoading
  setPrcentageCorrect = usePricing.getState().actions.setPrcentageCorrect
  setRecommendation = usePricing.getState().actions.setRecommendation

  constructor() {
    this.name = "subscription-pricing";

    this.MSubscriptionPricing = SubscriptionPricingModel();
  }

  init = _.once(async () => {
    await this.findTable()
  });


  findTable = async () => {
    this.setLoading(true)
    try {
      const result = await this.MSubscriptionPricing.findTable();
      if (!result) return

      this.setTable(result.table || {})
      this.setPrcentageCorrect(result.percentageCorrect ?? false)
      this.setRecommendation(result.recommendation ?? false)
    } finally {
      this.setLoading(false)
    }
  };
}
